import React, {Component} from 'react';
import Alert from "react-bootstrap/Alert";
import Button from "react-bootstrap/Button";
import Col from "react-bootstrap/Col";
import Container from "react-bootstrap/Container";
import Form from "react-bootstrap/Form";
import FormGroup from "react-bootstrap/FormGroup";
import Row from "react-bootstrap/Row";
import {Link} from "react-router-dom";
import { LOGO_URL } from '../../Settings';

// https://medium.com/@dakota.lillie/django-react-jwt-authentication-5015ee00ef9a

export default class LoginForm extends Component {

    constructor(props) {
        super(props);
        this.state = {
            success: false,

            errors: {},
            submitted: false,
            isSaved: true,
            isValid: false,
            eventType: null,
            eventTypeFrequency: {},

            id: null,

            username: '',
            usernameIsValid: false,
            usernameValidationmessage: '',
            password: '',
            passwordIsValid: false,
            passwordValidationmessage: '',

        };

        this.onFieldChange = this.onFieldChange.bind(this);
        this.onSubmit = this.onSubmit.bind(this);
        this.submitSuccess = this.submitSuccess.bind(this);
        this.submitFailure = this.submitFailure.bind(this);
    }

    onFieldChange(event) {
        const isValid = event.target.validity.valid;
        const validationMessage = event.target.validationMessage;
        const fieldName = event.target.name;
        let newStates = {isSaved: false};
        newStates.isValid = !validationMessage;
        newStates[fieldName] = event.target.value;
        const isValidName = fieldName + 'IsValid';
        newStates[isValidName] = isValid;
        const validationMessageName = fieldName + 'ValidationMessage';
        newStates[validationMessageName] = validationMessage;
        this.setState(newStates);
    }

    submitFailure(data) {
        this.setState({errors: data})
    }


    clickLoginCallback(data) {
    }

    submitSuccess(data) {
        if (!!!data) {
            return;
        }
        // Do nothing for now.
        this.setState({success: true});

        // TODO: Re-enable click login tracking.
        // this.props.authenticator.queuedPost(
        //     'click_login',
        //     {},
        //     this.clickLoginCallback, () => {
        // });
    }

    onSubmit(event) {
        event.preventDefault();
        this.props.authenticator.loginWithCallback(
            this.state.username,
            this.state.password,
            this.submitSuccess,
            this.submitFailure
        )
    }

    render() {

        if (this.state.success) {
            return <></>
            // if (this.props.next && this.props.next !== '/login') {
            //     return <Navigate to={this.props.next}/>
            // }
            // return <Navigate to={'/'}/>
        }

        return (
            <>
                <Container>
                    <Row>
                        <Col>
                            <img
                                src={LOGO_URL}
                                width={'50%'}
                                height={'auto'}
                                alt={'hsh-logo'}
                                style={{
                                    display: 'block',
                                    marginLeft: 'auto',
                                    marginRight: 'auto',
                                    width: '50%'
                                }}
                            />
                        </Col>
                    </Row>
                    <Row className="justify-content-center" style={{color:'white'}}>
                        <Col md={6}>
                            <Form
                                name={'user-registration-form'}
                                onSubmit={this.onSubmit}>
                                {/*<h4>{`${APPLICATION_TITLE}`} Log In</h4>*/}
                                {this.state.errors && this.state.errors.detail &&
                                    <Alert
                                        variant={'danger'}>{this.state.errors.detail}</Alert>}
                                {this.state.errors && this.state.errors.non_field_errors &&
                                    <Alert
                                        variant={'danger'}>{this.state.errors.non_field_errors}</Alert>}
                                <FormGroup>
                                    <Form.Label column={'username'}>
                                        Account Username
                                    </Form.Label>
                                    <Form.Control type="text"
                                                  id={'username'}
                                                  name={'username'}
                                                  autoComplete="username"
                                                  onChange={this.onFieldChange}
                                                  value={this.state.username}
                                                  isInvalid={!!this.state.errors.username}
                                                  placeholder={'Username'}
                                                  required
                                    />
                                    <Form.Control.Feedback type="invalid">
                                        {this.state.errors.username}
                                    </Form.Control.Feedback>
                                    <Form.Control.Feedback type="invalid">
                                        {this.state.usernameValidationmessage}
                                    </Form.Control.Feedback>
                                    <Form.Label column={'password'}>
                                        Password
                                    </Form.Label>
                                    <Form.Control type="password"
                                                  id={'password'}
                                                  name={'password'}
                                                  autoComplete="current-password"
                                                  onChange={this.onFieldChange}
                                                  value={this.state.password}
                                                  isInvalid={this.state.errors.user && !!this.state.errors.user.password}
                                                  placeholder={'Password'}
                                                  minLength={9}
                                    />
                                    <Form.Control.Feedback type="invalid">
                                        {this.state.errors.user && this.state.errors.user.password}
                                    </Form.Control.Feedback>
                                    <Form.Control.Feedback type="invalid">
                                        {this.state.passwordValidationmessage}
                                    </Form.Control.Feedback>
                                    <Button variant="stem"
                                            type="submit"
                                            style={{width:'100%'}}
                                    >Agree & Login</Button>
                                </FormGroup>
                            </Form>
                        </Col>
                    </Row>
                    <br/>
                    <hr/>
                    <br/>
                    <Row className="justify-content-center">
                        <Col md={6} style={{textAlign:'center'}}>
                            <Link to={'/register'}>
                                <Button variant={'deep'}>New User Registration</Button>
                            </Link>
                        </Col></Row>
                    <br/>
                    <hr/>
                    <br/>
                    <Row className="justify-content-center">
                        <Col md={6} style={{textAlign:'center'}}>
                        <Link to={'/reset-password'}>
                            <Button variant={'honored'}>Forgot your password?</Button>
                        </Link>
                    </Col></Row>
                    <Row className="justify-content-center">
                        <Col md={6} style={{textAlign:'center'}}>
                            <a href="https://hauntedspacehotel.com/">
                                <Button variant={'dread'}>Home</Button>
                            </a>
                        </Col>
                    </Row>
                </Container></>
        );
    }
}
